import { TurretActor } from "./turret-actors/TurretActor";
import { BattleScene } from "./BattleScene";
import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { BoardContainer } from "./board-container/BoardContainer";
import { GameManager } from "../../GameManager";
import * as Anuto from "../../../engine/src";

export class BattleManager {

    public static anutoEngine: Anuto.Engine;

    public static init(): void {  

        GameVars.battleOver = false;
        GameVars.enemiesPathsCells = GameVars.currentMapData.paths;
        GameVars.plateausCells = GameVars.currentMapData.plateaus;
        
        const gameConfig: Anuto.Types.GameConfig = {
            timeStep: GameConstants.TIME_STEP,
            runningInClientSide: true,
            initialTimer: !(GameVars.currentMapZone === 0 && GameVars.currentMapCount === 0),
            enemySpawningDeltaTicks: GameConstants.ENEMY_SPAWNING_DELTA_TICKS,
            credits: GameVars.currentMapData.waves.initialCoins || 0,
            lifes: GameConstants.INITIAL_LIFES,
            boardSize: GameVars.currentMapData.size,
            enemiesPathsCells : GameVars.enemiesPathsCells,
            plateausCells: GameVars.plateausCells,
            suicideAttackCooldownTicks: GameConstants.SUICIDE_ATTACK_COOLDOWN_TICKS,
            suicideAttackDamage: GameConstants.SUICIDE_ATTACK_DAMAGE,
            freezeAttackCooldownTicks: GameConstants.FREEZE_ATTACK_COOLDOWN_TICKS,
            freezeAttackDuration: GameConstants.FREEZE_ATTACK_DURATION
        };

        GameVars.wavesData = GameVars.currentMapData.waves.waves;

        GameVars.logsObject = {
            actions: []
        };

        GameVars.timeStepFactor = 1;
        GameVars.currentWave = 1;
        GameVars.paused = false;
        GameVars.levelCompleted = null;

        GameVars.currentScene.anims.resumeAll();

        BattleManager.anutoEngine = new Anuto.Engine(gameConfig, GameVars.enemiesData, GameVars.turretsData, GameVars.wavesData, GameVars.modifiers);

        GameVars.levelObject = {
            engineVersion: BattleManager.anutoEngine.version,
            gameConfig: gameConfig,
            enemiesData: GameVars.enemiesData,
            turretsData: GameVars.turretsData,
            wavesData: GameVars.wavesData
        };
        
        BattleManager.anutoEngine.addEventListener(Anuto.Event.ENEMY_SPAWNED, BattleManager.onEnemySpawned, BattleManager);
        BattleManager.anutoEngine.addEventListener(Anuto.Event.ENEMY_REACHED_EXIT, BattleManager.onEnemyReachedExit, BattleManager);
        BattleManager.anutoEngine.addEventListener(Anuto.Event.BULLET_SHOT, BattleManager.onArrowShot, BattleManager);
        BattleManager.anutoEngine.addEventListener(Anuto.Event.REMOVE_BULLET, BattleManager.onArrowImpacted, BattleManager);
        BattleManager.anutoEngine.addEventListener(Anuto.Event.GLUE_BULLET_SHOT, BattleManager.onGlueBulletShot, BattleManager);
        BattleManager.anutoEngine.addEventListener(Anuto.Event.ENEMY_HIT, BattleManager.onEnemyHit, BattleManager);
        BattleManager.anutoEngine.addEventListener(Anuto.Event.ENEMY_SPEED, BattleManager.onEnemySpeed, BattleManager);
        BattleManager.anutoEngine.addEventListener(Anuto.Event.ENEMY_HEAL, BattleManager.onEnemyHeal, BattleManager);
        BattleManager.anutoEngine.addEventListener(Anuto.Event.GLUE_SHOT, BattleManager.onGlueShot, BattleManager);   
        BattleManager.anutoEngine.addEventListener(Anuto.Event.REMOVE_GLUE_BULLET, BattleManager.removeGlueBullet, BattleManager);
        BattleManager.anutoEngine.addEventListener(Anuto.Event.ENEMY_BZZT_HIT, BattleManager.onEnemyGlueHit, BattleManager);
        BattleManager.anutoEngine.addEventListener(Anuto.Event.ENEMY_KILLED, BattleManager.onEnemyKilled, BattleManager);
        BattleManager.anutoEngine.addEventListener(Anuto.Event.LASER_SHOT, BattleManager.onLaserBeamShot, BattleManager);
        BattleManager.anutoEngine.addEventListener(Anuto.Event.FIRE_SHOT, BattleManager.onFireBeamShot, BattleManager);
        BattleManager.anutoEngine.addEventListener(Anuto.Event.MORTAR_SHOT, BattleManager.onMortarShot, BattleManager);
        BattleManager.anutoEngine.addEventListener(Anuto.Event.ROCKET_SHOT, BattleManager.onRocketShot, BattleManager);
        BattleManager.anutoEngine.addEventListener(Anuto.Event.MINE_SHOT, BattleManager.onMineShot, BattleManager);
        BattleManager.anutoEngine.addEventListener(Anuto.Event.GLUE_CONSUMED, BattleManager.onGlueConsumed, BattleManager);
        BattleManager.anutoEngine.addEventListener(Anuto.Event.ENEMIES_TELEPORTED, BattleManager.onEnemiesTeleported, BattleManager);
        BattleManager.anutoEngine.addEventListener(Anuto.Event.NO_ENEMIES_ON_STAGE, BattleManager.onNoEnemiesOnStage, BattleManager);
        BattleManager.anutoEngine.addEventListener(Anuto.Event.WAVE_OVER, BattleManager.onWaveOver, BattleManager);
        BattleManager.anutoEngine.addEventListener(Anuto.Event.GAME_OVER, BattleManager.onGameOver, BattleManager);
        BattleManager.anutoEngine.addEventListener(Anuto.Event.ACTIVE_NEXT_WAVE, BattleManager.activeNextWave, BattleManager);
        BattleManager.anutoEngine.addEventListener(Anuto.Event.SUICIDE_SOLDIER_SPAWNED, BattleManager.onSuicideSoldierSpawned, BattleManager);
        BattleManager.anutoEngine.addEventListener(Anuto.Event.SUICIDE_SOLDIER_REACHED_EXIT, BattleManager.onSuicideSoldierReachedExit, BattleManager);
        BattleManager.anutoEngine.addEventListener(Anuto.Event.SUICIDE_SOLDIER_EXPLODED, BattleManager.onSuicideSoldierExploded, BattleManager);
        BattleManager.anutoEngine.addEventListener(Anuto.Event.SUICIDE_SOLDIER_AVAILABLE, BattleManager.onSuicideSoldierAvailable, BattleManager);
        BattleManager.anutoEngine.addEventListener(Anuto.Event.FREEZE_ATTACK_ENDED, BattleManager.onFreezeAttackEnded, BattleManager);
        BattleManager.anutoEngine.addEventListener(Anuto.Event.FREEZE_ATTACK_AVAILABLE, BattleManager.onFreezeAttackAvailable, BattleManager);
        BattleManager.anutoEngine.addEventListener(Anuto.Event.NEW_WAVE, BattleManager.newWaveLaunched, BattleManager);

        BattleManager.anutoEngine.addEventListener(Anuto.Event.TURRET_READY, BattleManager.onTurretReady, BattleManager);
        BattleManager.anutoEngine.addEventListener(Anuto.Event.TURRET_UPGRADED, BattleManager.onTurretUpgraded, BattleManager);
    }

    public static update(time: number, delta: number): void {

        BattleManager.anutoEngine.update();
    }

    public static pause(): void {

        GameVars.currentScene.anims.pauseAll();

        GameVars.paused = true;

        this.anutoEngine.paused = true;
    }

    public static resume(): void {

        GameVars.currentScene.anims.resumeAll();

        GameVars.paused = false;

        this.anutoEngine.paused = false;
    }

    public static showSpecialAttack(type: number): void {

        if (GameVars.gameData.specialAttacks[type]) {
            return;
        }

        GameVars.gameData.specialAttacks[type] = true;

        BattleScene.currentInstance.showSpecialAttack(type);
    }

    public static setTimeStepFactor(timeStepFactor: number): void {

        GameVars.timeStepFactor = timeStepFactor;

        BattleManager.anutoEngine.timeStep = GameConstants.TIME_STEP / timeStepFactor;
    }

    public static newWave(noExtraCoins?: boolean): void {

        if (BattleManager.anutoEngine.newWave(noExtraCoins)) {

            const action = {type: GameConstants.TYPE_NEXT_WAVE, tick: BattleManager.anutoEngine.ticksCounter};
            BattleManager.addAction(action);
        }
    }

    public static newWaveLaunched(extraCredits: number): void {

        if (extraCredits > 0) {
            BattleScene.currentInstance.gui.showExtraCredits(extraCredits);
        }
        BattleScene.currentInstance.gui.hideNextWave();
    }

    public static addTurretToScene(type: string, position: {r: number, c: number}): void {

        BoardContainer.currentInstance.addTurret(type, position);
        BattleManager.hideSelectTurret();
    }

    public static addTurret(type: string, position: {r: number, c: number}, skipBuild?: boolean, level?: number): Anuto.Turret {

        let turret = BattleManager.anutoEngine.addTurret(type, position, skipBuild, level);

        if (turret) {
            let action = {type: GameConstants.TYPE_ADD_TURRET, tick: BattleManager.anutoEngine.ticksCounter, turretType: turret.type, position: position};
            BattleManager.addAction(action);
        }

        return turret;
    }

    public static sellTurret(turret: Anuto.Turret): void {

        if (BattleManager.anutoEngine.sellTurret(turret.id)) {

            let action = {type: GameConstants.TYPE_SELL_TURRET, tick: BattleManager.anutoEngine.ticksCounter, id: turret.id};
            BattleManager.addAction(action);

            BoardContainer.currentInstance.removeTurret(turret);
        }
    }

    public static onClickMenu(): void {

        BattleScene.currentInstance.showPauseMenu();
    }

    public static launchSuicideAttack(): void { 
        
        BattleManager.anutoEngine.launchSuicideAttack();
    }

    public static onSuicideSoldierSpawned(suicideSoldier: Anuto.SuicideSoldier): void {

        BattleScene.currentInstance.addSuicideSoldier(suicideSoldier);
    }

    public static onSuicideSoldierAvailable(): void {

        BattleScene.currentInstance.onSuicideSoldierAvailable();
    }

    public static onSuicideSoldierReachedExit(suicideSoldier: Anuto.SuicideSoldier): void {

        BoardContainer.currentInstance.onSuicideSoldierReachedExit(suicideSoldier);
    }

    public static onSuicideSoldierExploded(suicideSoldier: Anuto.SuicideSoldier, enemies: Anuto.Enemy[]): void {

        BoardContainer.currentInstance.onSuicideSoldierExploded(suicideSoldier, enemies);
    }

    public static launchFreezeAttack(): void {

        BattleScene.currentInstance.onFreezeAttackLaunched();
    }

    public static onFreezeAttackDeployed(): void {
        
        BattleManager.anutoEngine.launchFreezeAttack();
    }

    public static onFreezeAttackEnded(): void {
        
        BoardContainer.currentInstance.board.removeFreezeAttack();
    }

    public static onFreezeAttackAvailable(): void {

        BattleScene.currentInstance.onFreezeAttackAvailable();
    }

    public static onTurretReady(id: number): void {

        BoardContainer.currentInstance.onTurretReady(id);
    }

    public static upgradeTurret(id: number): void {

        const sucess = BattleManager.anutoEngine.upgradeTurret(id);

        if (sucess) {
            let action = {type: GameConstants.TYPE_LEVEL_UP_TURRET, tick: BattleManager.anutoEngine.ticksCounter, id: id};
            BattleManager.addAction(action);

            BoardContainer.currentInstance.setTowerToUpgrade(id);
        }
    }

    public static onTurretUpgraded(id: number): void {

        BoardContainer.currentInstance.onTurretUpgraded(id);
    }

    public static setNextStrategy(id: number): void {

        if (BattleManager.anutoEngine.setNextStrategy(id)) {
            let action = {type: GameConstants.TYPE_CHANGE_STRATEGY_TURRET, tick: BattleManager.anutoEngine.ticksCounter, id: id};
            BattleManager.addAction(action);
        }
    }

    public static setFixedTarget(id: number): void {

        if (BattleManager.anutoEngine.setFixedTarget(id)) {
            let action = {type: GameConstants.TYPE_CHANGE_FIXED_TARGET_TURRET, tick: BattleManager.anutoEngine.ticksCounter, id: id};
            BattleManager.addAction(action);
        }
    }

    public static createRangeCircle(range: number, x: number, y: number): Phaser.GameObjects.Image {

        return BoardContainer.currentInstance.createRangeCircle(range, x, y);
    }

    public static hideRangeCircles(): void {

        BoardContainer.currentInstance.hideRangeCircles();
    }

    public static showTurretMenu(anutoTurret: Anuto.Turret): void {

        BattleScene.currentInstance.showTurretMenu(anutoTurret);
    }

    public static hideTurretMenu(): void {

        BattleScene.currentInstance.hideTurretMenu();
    }

    public static hideNextWave(): void {

        BattleScene.currentInstance.hideNextWave();
    }

    public static showSelectTurret(x: number, y: number): void {

        BattleScene.currentInstance.showSelectTurret(x, y);
    }

    public static hideSelectTurret(): void {

        BattleScene.currentInstance.hideSelectTurret();
    }

    public static killAllWaveEnemies(): void {

        BattleManager.anutoEngine.killAllWaveEnemies();
    }

    private static onGameOver(): void {

        GameVars.battleOver = true;
    
        BattleScene.currentInstance.showGameOverLayer();

        GameManager.writeGameData();
    }

    private static onWin(): void {

        GameVars.battleOver = true;

        // si estamos en un nivel de tutorial liberar el ataque especial
        if (GameVars.currentMapZone === 0) {
            if (GameVars.currentMapCount === 0) {
                GameVars.gameData.initialTutorial = false;
            } if (GameVars.currentMapCount === 1) {
                GameVars.gameData.specialAttacks[0] = true;
            } else if (GameVars.currentMapCount === 2) {
                GameVars.gameData.specialAttacks[1] = true;
            }
        }

        GameVars.coinsEarned = 0;
        GameVars.coinsBaseEarned = 0;

        let countMap = GameVars.currentMapZone * 5 + GameVars.currentMapCount;
        let firstTimePassed = false;

        if (GameVars.gameData.progression[GameVars.currentMapZone].mapsProgress[GameVars.currentMapCount].stars < 1) {
            GameVars.coinsBaseEarned = (countMap + 1) * 90;
            firstTimePassed = true;
        }

        GameVars.coinsEarned = Math.round(((countMap + 1) * 90) / 3) * Math.ceil((BattleManager.anutoEngine.lifes / GameConstants.INITIAL_LIFES) * 3);
        GameVars.currentStars = Math.ceil((BattleManager.anutoEngine.lifes / GameConstants.INITIAL_LIFES) * 3);
        GameVars.gameData.coins += GameVars.coinsBaseEarned + GameVars.coinsEarned;

        if (GameVars.gameData.progression[GameVars.currentMapZone].mapsProgress[GameVars.currentMapCount].stars < Math.ceil((BattleManager.anutoEngine.lifes / GameConstants.INITIAL_LIFES) * 3)) {
            GameVars.levelCompleted = {zone: GameVars.currentMapZone, map: GameVars.currentMapCount, prevStars: GameVars.gameData.progression[GameVars.currentMapZone].mapsProgress[GameVars.currentMapCount].stars, totalPrevStars: GameManager.getTotalStars(), needUnlock: false};
            GameVars.gameData.progression[GameVars.currentMapZone].mapsProgress[GameVars.currentMapCount].stars = Math.ceil((BattleManager.anutoEngine.lifes / GameConstants.INITIAL_LIFES) * 3);
        }

        BattleScene.currentInstance.showWinLayer();

        GameVars.currentMapCount++;
        if (GameVars.currentMapCount === GameVars.gameData.progression[GameVars.currentMapZone].mapsProgress.length) {
            GameVars.currentMapCount = 0;
            GameVars.gameData.progression[GameVars.currentMapZone].completed = true;
            GameVars.currentMapZone++;
        }

        if (GameVars.currentMapZone < GameVars.gameData.progression.length) {
            if (!GameVars.gameData.progression[GameVars.currentMapZone].mapsProgress[GameVars.currentMapCount].unlocked) {
                GameVars.levelCompleted.needUnlock = true;
            }
            GameVars.gameData.progression[GameVars.currentMapZone].mapsProgress[GameVars.currentMapCount].unlocked = true;
        }

        GameManager.onLevelOver(true, firstTimePassed);

        GameManager.writeGameData();
    }

    private static addAction(action: any): void {

        GameVars.logsObject.actions.push(action);
    }

    private static onEnemySpawned(anutoEnemy: Anuto.Enemy, p: {r: number, c: number} ): void {
        
        BoardContainer.currentInstance.addEnemy(anutoEnemy, p);
    }

    private static onEnemyReachedExit(anutoEnemy: Anuto.Enemy): void {

        BoardContainer.currentInstance.removeEnemy(anutoEnemy.id);
        BattleScene.currentInstance.hud.updateLifes();
    }

    private static onArrowShot(anutoBullet: Anuto.Bullet, anutoProjectileTurret: Anuto.PeaTurret): void {

        BoardContainer.currentInstance.addBullet(anutoBullet, anutoProjectileTurret);
    }

    private static onGlueBulletShot(anutoBullet: Anuto.GlueBullet, anutoGlueTurret: Anuto.SplatTurret): void {

        BoardContainer.currentInstance.addGlueBullet(anutoBullet, anutoGlueTurret);
    }

    private static onLaserBeamShot(anutoLaserTurret: Anuto.BzztTurret, anutoEnemies: Anuto.Enemy[]): void {

        BoardContainer.currentInstance.addLaserBeam(anutoLaserTurret, anutoEnemies);
    }

    private static onFireBeamShot(anutoLaserTurret: Anuto.FireTurret, anutoEnemies: Anuto.Enemy[]): void {

        BoardContainer.currentInstance.addFireBeam(anutoLaserTurret, anutoEnemies);
    }

    private static onMortarShot(anutoMortar: Anuto.Mortar, anutoLaunchTurret: Anuto.MortarTurret): void {

        BoardContainer.currentInstance.addMortar(anutoMortar, anutoLaunchTurret);
    }

    private static onRocketShot(anutoMortar: Anuto.Mortar, anutoLaunchTurret: Anuto.RocketsTurret): void {

        BoardContainer.currentInstance.addRocket(anutoMortar, anutoLaunchTurret);
    }

    private static onMineShot(anutoMine: Anuto.Mine, anutoLaunchMine: Anuto.MinesTurret): void {

        BoardContainer.currentInstance.addMine(anutoMine, anutoLaunchMine);
    }

    private static onGlueShot(anutoGlue: Anuto.Glue, anutoGlueTurret: Anuto.SplatTurret): void {

        BoardContainer.currentInstance.addGlue(anutoGlue, anutoGlueTurret);
    }

    private static onGlueConsumed(anutoGlue: Anuto.Glue): void {

        BoardContainer.currentInstance.onGlueConsumed(anutoGlue);
    }

    private static onEnemyHit(anutoEnemies: Anuto.Enemy[], anutoBullet?: Anuto.Bullet, anutoMortar?: Anuto.Mortar, anutoMine?: Anuto.Mine, anutoFire?: boolean, anutoLaser?: boolean): void {

        let impactType: string = null;

        if (anutoBullet) {
            impactType = GameConstants.IMPACT_BULLET;
        } else if (anutoMortar) {
            impactType = GameConstants.IMPACT_MORTAR;
        } else if (anutoMine) {
            impactType = GameConstants.IMPACT_MINE;
        } else if (anutoFire) {
            impactType = GameConstants.IMPACT_FIRE;
        } else if (anutoLaser) {
            impactType = GameConstants.IMPACT_ELECTRIC;
        }

        for (let i = 0; i < anutoEnemies.length; i ++) {
            BoardContainer.currentInstance.onEnemyHit(anutoEnemies[i], impactType);
        }
        
        if (anutoBullet) {
            BoardContainer.currentInstance.onArrowImpacted(anutoBullet);
        } 

        if (anutoMortar) {
            BoardContainer.currentInstance.detonateMortar(anutoMortar);
        }

        if (anutoMine) {
            BoardContainer.currentInstance.detonateMine(anutoMine);
        }
    }

    private static onEnemySpeed(anutoEnemy: Anuto.Enemy): void {

        BoardContainer.currentInstance.onEnemySpeed(anutoEnemy.id);
    }

    private static onEnemyHeal(anutoEnemy: Anuto.Enemy): void {
        
        BoardContainer.currentInstance.onEnemyHeal(anutoEnemy.id);
    }

    private static onArrowImpacted(anutoArrow?: Anuto.Bullet) {

        BoardContainer.currentInstance.onArrowImpacted(anutoArrow);
    }

    private static removeGlueBullet(anutoGlueBullet: Anuto.GlueBullet): void {
        
        BoardContainer.currentInstance.removeGlueBullet(anutoGlueBullet);
    }

    private static onEnemyGlueHit(anutoEnemies: Anuto.Enemy[], anutoGlueBullet: Anuto.GlueBullet): void {

        for (let i = 0; i < anutoEnemies.length; i ++) {
            BoardContainer.currentInstance.onEnemyGlueHit(anutoEnemies[i]);
        }

        if (anutoGlueBullet) {
            BoardContainer.currentInstance.removeGlueBullet(anutoGlueBullet);
        } 
    }

    private static onEnemiesTeleported(teleportedEnemiesData: {enemy: Anuto.Enemy, teleportTurret: Anuto.TeleportTurret} []): void {
        

        for (let i = 0; i < teleportedEnemiesData.length; i++) {
            BoardContainer.currentInstance.teleportEnemy(teleportedEnemiesData[i].enemy, teleportedEnemiesData[i].teleportTurret);
        }
    }

    private static onEnemyKilled(anutoEnemy: Anuto.Enemy): void {

        BoardContainer.currentInstance.onEnemyKilled(anutoEnemy);
    }

    private static onNoEnemiesOnStage(): void {

        // 
    }

    private static onWaveOver(): void {

        if (BattleManager.anutoEngine.round >= Object.keys(GameVars.wavesData).length) {
            BattleManager.onWin();
            return; 
        }
       
        // BattleScene.currentInstance.gui.onClickNextWave();
    }

    private static activeNextWave(): void {

        if (BattleManager.anutoEngine.gameOver) {
            return;
        }
        
        BattleScene.currentInstance.gui.activeNextWave();
    }
}